import type {
  FilterConfig,
  FilterDefinition,
  FilterHandler,
} from '../engine/types';
import {
  FilterId,
  FilterType,
  type MultiFilter,
  type TreeFilter,
} from '../types/filters';
import { geographyDefinition, geographyHandler } from './geography';

export const multiGeographyDefinition: FilterDefinition<
  MultiFilter<TreeFilter>
> = {
  id: FilterId.MULTI_GEOGRAPHY,
  name: 'Geography',
  type: FilterType.MULTI,
  wrappedFilterId: FilterId.GEOGRAPHY,
  instances: [],
  isVisible: true,
};

export const multiGeographyHandler: FilterHandler<MultiFilter<TreeFilter>> = {
  isActive(currentFilterState: MultiFilter<TreeFilter>) {
    return currentFilterState.instances.some((instance) =>
      geographyHandler.isActive(instance)
    );
  },

  isDefault(
    currentFilterState: MultiFilter<TreeFilter>,
    _definition: FilterDefinition<MultiFilter<TreeFilter>>
  ) {
    return currentFilterState.instances.length === 0;
  },

  getEffectiveFilter(
    currentFilterState: MultiFilter<TreeFilter>,
    _definition: FilterDefinition<MultiFilter<TreeFilter>>,
    config: FilterConfig
  ) {
    const effectiveInstances = currentFilterState.instances.map((instance) =>
      geographyHandler.getEffectiveFilter(instance, geographyDefinition, config)
    );
    return { ...currentFilterState, instances: effectiveInstances };
  },
};
